import { Injectable } from '@angular/core';
import {
  Router,
} from '@angular/router';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {
  constructor(
    public authService: AuthService,
    public userService: UserService,
    public router: Router
  ) {}

  canActivate(): Observable<boolean> {
    var subject = new Subject<boolean>();

    this.userService.checkUserAuth().subscribe((user) => {
      if (user) {
        this.userService.user = user;
        this.userService.usertype = this.userService.user.usertype;
        subject.next(true);
      } else {
        subject.next(false);
      }
    });

    return subject.asObservable();
  }
}
